// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iIlX","colBig":"styles_colBig__2D6-2","colSmall":"styles_colSmall__eQeRL"};